<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{'action.sync' | transloco}}: {{model.title | uiLabel}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>

<nz-skeleton [nzActive]="true" [nzLoading]="isLoading.storeProducts" *transloco="let tr; prefix: 'productDefinitions'; scope: 'product-definitions'">
  <div nz-row [nzGutter]="8" *ngFor="let cr of storeProducts">
    <nz-divider [nzDashed]="true" [nzText]="cr.city.title | uiLabel" nzOrientation="left"></nz-divider>
    <div nz-col *ngFor="let st of cr.storeProducts; let last = last;">
      {{ st.store.title | uiLabel }} <span nz-tooltip [nzTooltipTitle]="tr('sync.product.tooltip')">({{st.storeProduct?.amount}} / {{st.reservedAmount}})</span>
      <nz-switch nzSize="small" [nzDisabled]="st.disabled" [(ngModel)]="st.checked" [nzControl]="true" (click)="syncStoreProduct(st)" [nzLoading]="st.loading"></nz-switch>
      <nz-divider [nzType]="'vertical'" *ngIf="!last"></nz-divider>
    </div>
  </div>
</nz-skeleton>
